import React, { useEffect, useMemo, useState } from 'react';
import { Topbar } from '../../components/include/Topbar';
// import '@ckeditor/ckeditor5-build-classic/build/ckeditor.css'; 
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/common/Loader';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';

const Add_performance = () => {
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [existingYears, setExistingYears] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  const isAccessible = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;


  const [formData, setFormData] = useState({
    performance_year: "",
    no_of_candidates: 1,
    mean_grade: "",
    summary: "",
    narrative: "",
  })

  const currentYear = new Date().getFullYear();

  const years = useMemo(() => {
    const temp = [];
    for (let year = 2015; year <= currentYear; year++) {
      if (!existingYears.includes(year.toString())) {
        temp.push(year.toString());
      }
    }
    return temp;
  }, [existingYears]);

  const validate = () => {
    const newErrors = {};
    if (!formData.performance_year) newErrors.performance_year = true;
    if (!formData.no_of_candidates) newErrors.no_of_candidates = true;
    if (!formData.mean_grade) newErrors.mean_grade = true;
    if (!formData.summary) newErrors.summary = true;
    if (!formData.narrative) newErrors.narrative = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoader(true);


    const form = new FormData();
    if (params.id) form.append("id", params.id);
    form.append("year", formData.performance_year);
    form.append("no_of_candidates", formData.no_of_candidates);
    form.append("mean_grade", formData.mean_grade);
    form.append("summary", formData.summary);
    form.append("narrative", formData.narrative);

    Postdata(HttpService.performance_add, form).then((res) => {
      if (res.status === 200) {
        navigate(`/education`, {
          replace: true,
          state: { currentTab: "Performance" },
        });
      }
      dispatch(message(res.message));
      setLoader(false)
    });
    console.log("Submitted as FormData:", formData);
  }

  const fetchList = () => {
    setLoader(true);
    Postdata(HttpService.performance_list).then((res) => {
      if (res.status === 200) {
        const yearsList = res.data.map(item => item.year);
        console.log("+++++++", yearsList);
        setExistingYears(yearsList);
      }else{

        dispatch(message(res.message));
      }
      setLoader(false)
    });
  }

  const fetchData = () => {
    setLoader(true)
    Postdata(HttpService.performance_show, { id: params.id }).then((res) => {
      if (res.status === 200) {
        // console.log("res.data>>>",res.data)
        setFormData({
          performance_year: res.data.year,
          no_of_candidates: res.data.no_of_candidates,
          mean_grade: res.data.mean_grade,
          summary: res.data.summary,
          narrative: res.data.narrative,
        })

      } else {
        dispatch(message(res.message));
      }
      setLoader(false)
    });
  }

  useEffect(() => {
    if (params.id) {

      fetchData()
    }
    fetchList()
  }, [])

  console.log(location.state?.type, "++++++++++++")
  if (loader) {
    return <Loader isClass="loader_fullscreen" />
  }

  if (!isAccessible) {
    return <Error403Page />
  }

  return (
    <>
      <Topbar title={location.state?.type == "edit" ? "Edit Performance" : "Add Performance"} aerrow={true} />

      <div className="p-6 bg-gray-100 min-h-screen">
        <form onSubmit={(e) => handleSubmit(e)}>


          {/* Inline Inputs */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {/* Performance Year */}
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Performance Year <span className="text-red-500">*</span>
              </label>
              {location.state?.type !== "edit" ? <select
                name="performance_year"
                className="input-field"
                value={formData.performance_year || ""}
                onChange={handleInputChange}
              >
                <option value="">  Select Performance Year  </option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select> :
                <input
                  type="text"
                  readOnly
                  className="input-field"
                  value={formData.performance_year}
                />
              }
              {errors.performance_year && (
                <span className="text-red-500 text-sm">Required</span>
              )}
            </div>

            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Total Number of Candidates <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                name="no_of_candidates"
                placeholder="Enter Total Number of Candidates"
                className="input-field"
                value={formData.no_of_candidates}
                onChange={handleInputChange}
                min={1}
                max={100}
              />
              {errors.no_of_candidates && (
                <span className="text-red-500 text-sm">Required</span>
              )}
            </div>

            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Mean Grade<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="mean_grade"
                placeholder="Enter Mean Grade"
                className="input-field"
                value={formData?.mean_grade}
                onChange={handleInputChange}
                maxLength={2}
              />
              {errors.mean_grade && (
                <span className="text-red-500 text-sm">Required</span>
              )}
            </div>

          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Performance Summary<span className="text-red-500">*</span>
            </label>
            <textarea

              name="summary"
              placeholder="Enter Performance Summary"
              className="input-field"
              value={formData.summary}
              onChange={handleInputChange}
            />
            {errors.summary && (
              <span className="text-red-500 text-sm">Required</span>
            )}
          </div>
          <div >
            <label className="block mb-1 font-medium text-gray-700">
              Performance Narrative<span className="text-red-500">*</span>
            </label>
            <CKEditor
              editor={ClassicEditor}
              data={formData.narrative}
              config={{
                placeholder: "Write Here"
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setFormData({ ...formData, narrative: data });
              }}
            />
            {errors.narrative && (
              <span className="text-red-500 text-sm">Required</span>
            )}
          </div>
          <div className="w-full flex justify-center gap-3 mb-2 mt-4">
            <button
              type="submit"
              className="button-field-primary"
              style={{ width: "30%" }}
              disabled={loader}
            >
              {loader ? 'Please wait...' : ('Submit')}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Add_performance;
